export default __webpack_public_path__ + "static/LogoNeu-3528d384dab36578ef98923bf6ee53c1.jpg";